import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {CostRegistrationRelations} from "../../models/cost_registration_relations";
import Helpers from "../../utils/helpers";

@Injectable()
export class CostRegistrationsControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getCostRegistrationsRelationsList(serviceId: string): Observable<CostRegistrationRelations[][]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/cost_registration_relations") as Observable<CostRegistrationRelations[][]>;
  }

  public saveCostRegistrations(serviceId: string, costRegistrationRelations: CostRegistrationRelations) {
    Helpers.trimRecursiveObj(costRegistrationRelations);
    const body = JSON.stringify(costRegistrationRelations);
    return this.http.post(this.baseUrl + "cost_requirement_registration", body);
  }

}
